import React from "react";

const Diwali = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M33.063 20.814h-.968c-3.156 0-6.44-.857-9.635-2.548-3.016-1.595-5.904-1.595-8.92 0-3.195 1.69-6.478 2.548-9.635 2.548h-.967A.937.937 0 002 21.75c0 .995.092 1.932.272 2.813h1.633c3.777 0 7.65-1.004 11.39-2.984 1.923-1.015 3.49-1.015 5.41 0 3.74 1.98 7.614 2.984 11.39 2.984h1.634c.18-.88.272-1.818.272-2.813a.937.937 0 00-.938-.937z"
            fill={fill}
        />
        <path className="u_fill"
            d="M32.097 26.437c-4.085 0-8.254-1.077-12.267-3.201-1.366-.722-2.29-.722-3.657 0-4.012 2.124-8.181 3.201-12.266 3.201H2.84C4.754 31.305 10.003 34 18 34c8 0 13.248-2.695 15.162-7.563h-1.066zm-19.72 1.875a.938.938 0 110-1.875.938.938 0 010 1.875zm5.625 1.875a2.816 2.816 0 01-2.813-2.812 2.816 2.816 0 012.813-2.813 2.816 2.816 0 012.812 2.813 2.816 2.816 0 01-2.812 2.812zm5.625-1.875a.938.938 0 110-1.875.938.938 0 010 1.875z"
            fill={fill}
        />
        <path className="u_fill"
            d="M18 28.313a.937.937 0 100-1.875.937.937 0 000 1.875zM15.562 12.847l1.626-2.816c.335-.58 1.29-.58 1.624 0l1.625 2.814c.15.26.24.545.301.836.623-.837 1.012-1.95 1.012-3.18 0-1.89-2.057-6.56-2.94-8.07-.337-.575-1.282-.575-1.619 0-.884 1.51-2.94 6.18-2.94 8.07 0 1.23.388 2.343 1.011 3.18.06-.291.151-.575.3-.834z"
            fill={fill}
        />
        <path className="u_fill"
            d="M18 12.375l-.813 1.408a.938.938 0 101.625-.002L18 12.375z"
            fill={fill}
        />
    </svg>
);
export default Diwali;